import { writable } from 'svelte/store';
import type { Coop } from '$lib/coop.svelte';

export type NavCoop = {
	coop: Coop;
	roomId: string;
};

/** Set by a game page while it's in an active (non-solo) co-op room; the top
 *  nav renders the player badges + skip/leave actions from it. */
export const navCoop = writable<NavCoop | null>(null);

export type NavHint = {
	label: string;
	action: () => void;
	count?: number;
};

export const navHint = writable<NavHint | null>(null);

export type NavCrosswordControls = {
	onclear: () => void;
	oncheckword: () => void;
	oncheckpuzzle: () => void;
};

export const navCrosswordControls = writable<NavCrosswordControls | null>(null);

export type NavGameControl = {
	label: string;
	icon: string;
	action: () => void;
	/** Pixel-frame palette, matching the word-cross menu actions. */
	tone?: 'nav' | 'present' | 'absent' | 'correct';
};

export const navGameControl = writable<NavGameControl | null>(null);
